export const siteSettings = {
  name: "Chroma Finex Hub",
  link: "https://chromafinexhub.net",
  email: "support@chromafinexhub.net",
  appLink: "https://app.chromafinexhub.net",
};
